import React, { useState } from 'react'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'

const TERMS = [
  { term: 'Arbitrage', def: 'Simultaneously buying and selling the same asset across two markets to profit from a temporary price difference.' },
  { term: 'Spread', def: 'The gap between an asset\'s buy (ask) price and sell (bid) price on a given exchange.' },
  { term: 'Slippage', def: 'The difference between the expected price of a trade and the price at which it actually executes, usually caused by fast-moving markets.' },
  { term: 'Funding Rate', def: 'A periodic payment exchanged between long and short holders of a perpetual futures contract, used to keep its price aligned with the spot market.' },
  { term: 'Basis Trade', def: 'A strategy that profits from the price difference between a spot asset and its corresponding futures contract.' },
  { term: 'Liquidity', def: 'How easily an asset can be bought or sold without significantly moving its price. Deeper liquidity generally means tighter spreads.' },
  { term: 'Leverage', def: 'Borrowed capital used to increase the size of a trading position beyond what your own deposited funds would otherwise allow.' },
  { term: 'Margin Call', def: 'A warning that your account equity has fallen close to the minimum required to keep a leveraged position open.' },
  { term: 'Stop Out', def: 'The point at which an exchange or broker automatically closes a leveraged position because available margin has fallen too low.' },
  { term: 'Pip', def: 'The smallest standardised price movement for a given instrument, commonly used to measure spread and price change in forex.' },
  { term: 'CFD', def: 'Contract for Difference — a derivative that lets you speculate on an asset\'s price movement without owning the underlying asset itself.' },
  { term: 'Order Book', def: 'The live list of buy and sell orders for an asset on an exchange, ranked by price.' },
  { term: 'Negative Balance Protection', def: 'A safeguard that prevents your account balance from going below zero, even during extreme, fast-moving market conditions.' },
  { term: 'Swap', def: 'A fee (or credit) applied when a leveraged position is held open overnight, reflecting the interest rate difference between the two assets involved.' },
]

export default function Glossary() {
  const [query, setQuery] = useState('')
  const filtered = TERMS.filter(t => t.term.toLowerCase().includes(query.toLowerCase()))

  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xgl-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px; }
      `}</style>
      <PublicNav active="Resources" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Learn</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>Glossary</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '560px', margin: '0 auto' }}>Quick definitions for trading terms used across the platform.</p>
      </section>

      <section style={{ padding: '64px 24px', maxWidth: '1000px', margin: '0 auto' }}>
        <input
          type="text"
          placeholder="Search terms..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          style={{
            width: '100%', maxWidth: '360px', display: 'block', margin: '0 auto 40px', padding: '12px 18px',
            fontSize: '14px', border: `1px solid ${C.bdr}`, borderRadius: '999px', background: C.light, color: C.tx,
            fontFamily: fBody, outline: 'none',
          }}
        />
        <div className="xgl-grid">
          {filtered.map(t => (
            <div key={t.term} style={{ background: C.light, border: `1px solid ${C.bdr}`, borderRadius: '12px', padding: '18px' }}>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '17px', color: C.tx, marginBottom: '6px' }}>{t.term}</div>
              <p style={{ fontSize: '14px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{t.def}</p>
            </div>
          ))}
        </div>
        {filtered.length === 0 && (
          <p style={{ textAlign: 'center', color: C.tx3, fontSize: '14px' }}>No terms match "{query}".</p>
        )}
      </section>

      <PublicFooter />
    </div>
  )
}
